import React from 'react';
import styled from 'styled-components';

import Icon from '../atom/Icon';
import { Text } from '../atom/Text';

import { getUserAgentValue } from '../../../lib/util/UserAgent';

export const DownloadButton = ({ eventHandler, type = 'video' || 'image' }) => {
  const { isMobile } = getUserAgentValue();

  // 이미지 다운로드를 blob 형식으로 요청하는 경우 모바일에서 지원하지 않는 브라우저가 있어 텍스트처리함
  if (isMobile && type === 'image') {
    return <ImageDownloadGuide />;
  }

  return (
    <Button onClick={eventHandler}>
      <Icon iconName="cloud_download" />
      &ensp;다운받기
    </Button>
  );
};

const Button = styled.a`
  display: flex;
  align-items: center;
  color: #7a7d86;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const ImageDownloadGuide = () => {
  const { isMobile } = getUserAgentValue();

  return (
    <Text color="orangePink" size={12} style={{ marginBottom: '1.25rem' }}>
      *{isMobile ? GUIDE_TO_DOWNLOAD_IMAGE_MOBILE : GUIDE_TO_DOWNLOAD_IMAGE_PC}
    </Text>
  );
};

export const GUIDE_TO_DOWNLOAD_IMAGE_MOBILE =
  "다운로드를 원하시는 경우, 이미지를 2초간 길게 누른 후 '이미지 저장'을 클릭해주세요";
export const GUIDE_TO_DOWNLOAD_IMAGE_PC =
  '다운로드를 원하시는 경우, 마우스 우클릭 후 ‘다른 이름으로 이미지 저장’을 클릭해주세요.';
